import * as Sentry from '@sentry/react';

// Init Sentry as early as possible (before React renders) so unhandled errors
// in the bootstrap path are still captured. No-op when DSN isn't set, which
// keeps local dev quiet unless the developer opts in.
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Sample 10% of transactions — keeps us under the 10k events/mo free tier
    tracesSampleRate: 0.1,
    // Session replay only on errors — free tier allows 50/mo
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Drop third-party in-app browser noise: Meta/TikTok/etc inject scripts
    // (iabjs://navigation_performance_logger_android) that postMessage to the
    // native Java side; when the IAB is closed, the Java object is gone and
    // the script throws. Not our code, not user-impacting — silence it.
    ignoreErrors: ['Java object is gone'],
    denyUrls: [/^iabjs:\/\//i],
  });
}

export { Sentry };
